export default __webpack_public_path__ + "static/media/RyanGIF.977a65aa.gif";